// extracted by mini-css-extract-plugin
export var root = "styles-module--root--3HurP";
export var content = "styles-module--content--3c29L";
export var left = "styles-module--left--1g7cx";
export var right = "styles-module--right--2CYLT";
export var logo = "styles-module--logo--3hAsK";